module.exports = __webpack_public_path__ + "img/8-1_04.260cf927.jpg";